export const messages = {
  en: {
    auditAuthOwner: {
      searchTitle: 'Search Conditions',
      authTitle: 'Owner Property Certification',
      appUserNamePlaceholder: 'Please enter associated owner name',
      idCardPlaceholder: 'Please enter associated owner ID card',
      linkPlaceholder: 'Please enter associated owner phone',
      communityName: 'Community Name',
      owner: 'Owner',
      phone: 'Phone',
      room: 'Room',
      ownerType: 'Person Type',
      idCard: 'ID Card',
      state: 'Status',
      remark: 'Audit Remark',
      createTime: 'Application Time',
      appType: 'App Type',
      operation: 'Operation',
      audit: 'Audit',
      resetPwd: 'Reset Password',
      all: 'All',
      pending: 'Pending',
      success: 'Success',
      failed: 'Failed',
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    auditAuthOwner: {
      searchTitle: '查询条件',
      authTitle: '业主房产认证',
      appUserNamePlaceholder: '请输入关联业主名称',
      idCardPlaceholder: '请输入关联业主身份证',
      linkPlaceholder: '请输入关联业主手机号',
      communityName: '小区名称',
      owner: '业主',
      phone: '手机号',
      room: '房屋',
      ownerType: '人员类型',
      idCard: '身份证',
      state: '状态',
      remark: '审核说明',
      createTime: '申请时间',
      appType: '手机端类型',
      operation: '操作',
      audit: '审核',
      resetPwd: '重置密码',
      all: '全部',
      pending: '待审核',
      success: '审核成功',
      failed: '审核失败',
      fetchError: '获取数据失败'
    }
  }
}